import { I18Module } from './I18Module';

export class I18ServerModule extends I18Module {}

export default I18ServerModule;
